(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["lc-approved-entries"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lc-approved-entries')) {
    customElements.define('lc-approved-entries', class extends HTMLElement {
      connectedCallback() {
        if (this._ready) return;
        this._ready = true;
        this.track = this.querySelector('.lc-entries__track');
        this.cards = [...this.querySelectorAll('.lc-entries__card')];
        this.previous = this.querySelector('.lc-entries__previous');
        this.next = this.querySelector('.lc-entries__next');
        this.position = this.querySelector('[data-lc-position]');
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        const update = () => {
          const step = this.cards[1] ? this.cards[1].offsetLeft - this.cards[0].offsetLeft : 1;
          this.index = Math.max(0, Math.min(this.cards.length - 1, Math.round(this.track.scrollLeft / Math.max(1, step))));
          this.position.textContent = String(this.index + 1).padStart(2, '0');
          this.previous.disabled = this.index === 0;
          this.next.disabled = this.index === this.cards.length - 1;
        };
        const go = (delta) => {
          const index = Math.max(0, Math.min(this.cards.length - 1, (this.index || 0) + delta));
          const left = this.cards[index].offsetLeft - this.cards[0].offsetLeft;
          this.track.scrollTo({ left, behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth' });
        };
        this.previous.addEventListener('click', () => go(-1), options);
        this.next.addEventListener('click', () => go(1), options);
        this.track.addEventListener('scroll', update, { ...options, passive: true });
        this.track.addEventListener('keydown', event => {
          if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') {
            event.preventDefault(); go(event.key === 'ArrowRight' ? 1 : -1);
          }
        }, options);
        this.observer = new ResizeObserver(update);
        this.observer.observe(this.track);
        update();
      }
      disconnectedCallback() {
        this.controller?.abort(); this.observer?.disconnect(); this._ready = false;
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lc-cart-offer-styles"] && !Shopify.designMode) return;
  try {
    (() => {
  const syncDeliveryNotes = () => {
    document.querySelectorAll('[data-cart-wrapper]').forEach(wrapper => {
      const state = wrapper.querySelector('[data-lc-delivery-state]');
      if (!state) return;
      wrapper.querySelectorAll('[data-lc-delivery-note]').forEach(note => {
        const hidden = state.dataset.requiresShipping !== 'true';
        if (note.hidden !== hidden) note.hidden = hidden;
        const text = state.dataset.shippingEarned === 'true' ? note.dataset.freeText : note.dataset.pendingText;
        if (note.textContent !== text) note.textContent = text;
      });
    });
  };
  const start = () => {
    syncDeliveryNotes();
    new MutationObserver(syncDeliveryNotes).observe(document.body, { childList: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lc-footer-editorial"] && !Shopify.designMode) return;
  try {
    function initializeLcFooter(root) {
    if (root.dataset.lcReady) return;
    root.dataset.lcReady = 'true';
    const media = window.matchMedia('(min-width: 768px)');
    const groups = Array.from(root.querySelectorAll('.lc-footer-editorial__group'));
    const sync = () => groups.forEach(group => { group.open = media.matches; });
    sync();
    media.addEventListener('change', sync);
    groups.forEach(group => {
      group.querySelector('summary').addEventListener('click', event => {
        if (media.matches) event.preventDefault();
      });
    });
  }
  document.querySelectorAll('[data-lc-footer]').forEach(initializeLcFooter);
  document.addEventListener('shopify:section:load', event => {
    event.target.querySelectorAll('[data-lc-footer]').forEach(initializeLcFooter);
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lc-home-editorial"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('lc-editorial-a')) {
    customElements.define('lc-editorial-a', class extends HTMLElement {
      connectedCallback() {
        if (this.cleanup) return;
        const abort = new AbortController();
        const observers = [];
        this.querySelectorAll('[data-media-group]').forEach(group => {
          const rail = group.querySelector('.lc-editorial-a__rail');
          const slides = [...rail.querySelectorAll('figure')];
          const prev = group.querySelector('[data-prev]'), next = group.querySelector('[data-next]'), count = group.querySelector('[data-count]');
          const index = () => {
            const left = rail.getBoundingClientRect().left;
            return slides.reduce((best,slide,i) => Math.abs(slide.getBoundingClientRect().left-left) < Math.abs(slides[best].getBoundingClientRect().left-left) ? i : best,0);
          };
          const sync = () => {
            const i = index();
            prev.disabled = i === 0; next.disabled = i === slides.length-1;
            count.textContent = String(i+1).padStart(2,'0')+' / '+String(slides.length).padStart(2,'0');
            if (matchMedia('(max-width:749px)').matches) {
              rail.style.setProperty('--rail-height',Math.ceil(slides[i].getBoundingClientRect().height)+'px');
              slides.forEach((slide,j) => {
                const video = slide.querySelector('video'); if(video && j !== i) video.pause();
              });
            } else {rail.style.removeProperty('--rail-height');}
          };
          const move = delta => {
            const i = Math.max(0,Math.min(slides.length-1,index()+delta));
            const left = rail.scrollLeft+slides[i].getBoundingClientRect().left-rail.getBoundingClientRect().left;
            rail.scrollTo({left,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
          };
          prev.addEventListener('click',()=>move(-1),{signal:abort.signal});
          next.addEventListener('click',()=>move(1),{signal:abort.signal});
          rail.addEventListener('scroll',sync,{passive:true,signal:abort.signal});
          rail.addEventListener('keydown',e=>{
            if(e.target !== rail)return;
            if(e.key === 'ArrowRight' || e.key === 'ArrowLeft'){e.preventDefault();move(e.key === 'ArrowRight'?1:-1);}
          },{signal:abort.signal});
          const resize = new ResizeObserver(sync);slides.forEach(slide=>resize.observe(slide));observers.push(resize);sync();
        });
        this.cleanup = () => {abort.abort();observers.forEach(observer=>observer.disconnect());};
      }
      disconnectedCallback() {if(this.cleanup){this.cleanup();this.cleanup=null;}}
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lc-newsletter-invitation"] && !Shopify.designMode) return;
  try {
    (() => {
  const dialog = document.getElementById('lc-newsletter-invitation');
  const teaser = document.getElementById('lc-newsletter-teaser');
  if (!dialog || !teaser || typeof dialog.showModal !== 'function') return;
  const dismissedKey = 'lc-invitation-dismissed-v1';
  const teaserKey = 'lc-invitation-teaser-v1';
  const preview = new URLSearchParams(location.search).get('newsletter_preview') === '1';
  let dismissed = false;
  let teaserMode = false;
  let openedThisPage = false;
  let showTeaserOnClose = false;
  let timer;
  let previousFocus;
  const success = Boolean(dialog.querySelector('[data-lc-invitation-success]'));
  try {
    const dismissedAt = Number(localStorage.getItem(dismissedKey));
    const teaserAt = Number(localStorage.getItem(teaserKey));
    dismissed = dismissedAt > 0 && Date.now() - dismissedAt < 7 * 86400000;
    teaserMode = teaserAt > 0 && Date.now() - teaserAt < 7 * 86400000;
  } catch (_) {}
  if (preview) { dismissed = false; teaserMode = false; }
  const rememberTeaser = () => {
    teaserMode = true;
    if (!preview) { try { localStorage.setItem(teaserKey, String(Date.now())); } catch (_) {} }
  };
  const dismissAll = () => {
    dismissed = true;
    teaserMode = false;
    teaser.hidden = true;
    if (!preview) {
      try {
        localStorage.setItem(dismissedKey, String(Date.now()));
        localStorage.removeItem(teaserKey);
      } catch (_) {}
    }
  };
  const stop = () => { clearInterval(timer); window.removeEventListener('scroll', tryOpen); };
  const showTeaser = () => { if (!dismissed && !success) teaser.hidden = false; };
  const open = () => {
    if (dialog.open) return;
    previousFocus = document.activeElement;
    teaser.hidden = true;
    showTeaserOnClose = !dismissed && !success;
    dialog.showModal();
    openedThisPage = true;
    stop();
  };
  const closeToTeaser = () => {
    showTeaserOnClose = !dismissed && !success;
    if (showTeaserOnClose) rememberTeaser();
    dialog.close();
  };
  dialog.querySelectorAll('[data-lc-invitation-close]').forEach(button => button.addEventListener('click', closeToTeaser));
  dialog.addEventListener('cancel', () => { showTeaserOnClose = !dismissed && !success; if (showTeaserOnClose) rememberTeaser(); });
  dialog.addEventListener('close', () => {
    if (showTeaserOnClose) showTeaser();
    if (previousFocus && typeof previousFocus.focus === 'function') previousFocus.focus();
  });
  dialog.addEventListener('click', event => { if (event.target !== dialog) return; const box = dialog.getBoundingClientRect(); if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) closeToTeaser(); });
  teaser.querySelector('[data-lc-invitation-reopen]').addEventListener('click', open);
  teaser.querySelector('[data-lc-invitation-teaser-close]').addEventListener('click', dismissAll);
  const start = Date.now();
  function tryOpen() {
    if (dismissed || openedThisPage || document.hidden || Date.now() - start < 30000 || window.scrollY < 180) return;
    if (document.querySelector('dialog[open], [role="dialog"][aria-modal="true"], .t4s-drawer[aria-hidden="false"], .shopify-pc__banner__dialog')) return;
    open();
  }
  if (dialog.querySelector('[data-lc-invitation-success], [data-lc-invitation-error]')) { if (success) dismissAll(); open(); return; }
  if (preview) { if (document.readyState === 'complete') open(); else window.addEventListener('load', open, {once:true}); return; }
  if (dismissed) return;
  if (teaserMode) { showTeaser(); return; }
  window.addEventListener('scroll', tryOpen, {passive:true});
  timer = setInterval(tryOpen, 3000);
  setTimeout(stop, 180000);
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lc-tout-voir-filter-ui"] && !Shopify.designMode) return;
  try {
    (() => {
  function prepare(wrapper) {
    if (wrapper.dataset.ready) return;
    wrapper.dataset.ready = '1';
    const min = wrapper.querySelector('[data-lc-min]'), max = wrapper.querySelector('[data-lc-max]');
    const slider = wrapper.querySelector('.t4s-price_steps_slider');
    const amount = wrapper.querySelector('.t4s-price_slider_amount');
    const rangeMax = Number(max.max);
    function validate() {
      min.setCustomValidity(''); max.setCustomValidity('');
      const low = min.value === '' ? 0 : Number(min.value), high = max.value === '' ? rangeMax : Number(max.value);
      if (!Number.isFinite(low) || !Number.isFinite(high) || low > high) max.setCustomValidity(wrapper.dataset.invalid);
      return min.checkValidity() && max.checkValidity();
    }
    function sync() {
      if (!validate()) return false;
      const low = min.value === '' ? 0 : Number(min.value), high = max.value === '' ? rangeMax : Number(max.value);
      amount.querySelector('.t4s-min_price').value = low;
      amount.querySelector('.t4s-max_price').value = high;
      if (slider.noUiSlider) slider.noUiSlider.set([Math.round(low * 100), Math.round(high * 100)]);
      return true;
    }
    [min, max].forEach(input => { input.addEventListener('input', validate); input.addEventListener('change', sync); input.addEventListener('keydown', event => { if(event.key === 'Enter'){event.preventDefault();wrapper.querySelector('.lc-price-apply').click();} }); });
    wrapper.querySelector('.lc-price-apply').addEventListener('click', event => {
      if (!sync()) { event.preventDefault(); event.stopImmediatePropagation(); min.reportValidity(); max.reportValidity(); }
    }, true);
    let attempts = 0;
    function bindSlider() {
      if (!wrapper.isConnected) return;
      if (!slider.noUiSlider) { if (++attempts < 50) setTimeout(bindSlider, 200); return; }
      slider.noUiSlider.on('update.lcPrice', values => { if(document.activeElement!==min)min.value=Number(values[0])/100;if(document.activeElement!==max)max.value=Number(values[1])/100; });
    }
    bindSlider();
  }
  function scan() { document.querySelectorAll('.lc-facets [data-lc-price]').forEach(prepare); }
  document.addEventListener('keydown', event => { if(event.key === ' ' && event.target.matches('.lc-facet-choice[role=checkbox][href]')){event.preventDefault();event.target.click();} });
  new MutationObserver(scan).observe(document.documentElement, {childList:true,subtree:true});
  scan();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lc-tout-voir-help"] && !Shopify.designMode) return;
  try {
    document.addEventListener('click', event => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-lc-browse-chat]') : null;
    if (!trigger || event.defaultPrevented || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const chat = document.querySelector('shopify-chat');
    if (chat?.hasAttribute('open')) { event.preventDefault(); return; }
    const activator = chat?.shadowRoot?.querySelector('button[part="activator"]');
    if (!activator) return;
    event.preventDefault();
    if (activator.getAttribute('aria-expanded') !== 'true') activator.click();
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lc-tout-voir-search"] && !Shopify.designMode) return;
  try {
    (() => {
  const normal = text => String(text || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim();
  function start() {
    const ui = document.querySelector('[data-lc-catalog-search]');
    if (!ui || ui.dataset.ready) return;
    ui.dataset.ready = '1'; ui.hidden = false;
    const input = ui.querySelector('input'), clear = ui.querySelector('[data-lc-clear]'), status = ui.querySelector('[role=status]');
    const section = ui.closest('.t4s-section-main');
    const mobileViewport = window.matchMedia('(max-width: 767px)');
    const updatePlaceholder = () => { input.placeholder = mobileViewport.matches ? input.dataset.placeholderMobile : input.dataset.placeholderDesktop; };
    updatePlaceholder();
    mobileViewport.addEventListener('change', updatePlaceholder);
    let state, generation = 0, timer;
    function countResults(value) {
      const counter = section.querySelector('[data-lc-browse-count]');
      if (!counter) return;
      counter.hidden = !state?.data.filtered && !input.value.trim();
      const text = typeof value === 'number' ? (value === 1 ? counter.dataset.one : counter.dataset.many).replace('__COUNT__', value) : value;
      if (counter.textContent !== text) counter.textContent = text;
    }
    input.value = new URL(location.href).searchParams.get('lc_q') || '';
    function collect(scope) {
      const metadata = scope.querySelector('[data-lc-search-data]');
      if (!metadata) throw new Error('Missing search metadata');
      const data = JSON.parse(metadata.textContent);
      const cards = [...scope.querySelectorAll('.t4s-products > .t4s-product')];
      const records = data.items.map(item => {
        const card = cards.find(card => JSON.parse(card.dataset.productOptions || '{}').id === item.id);
        if (!card) throw new Error('Missing product card');
        return { item, card: card.cloneNode(true) };
      });
      return { data, records, metadata };
    }
    function refresh() {
      const metadata = section.querySelector('[data-lc-search-data]');
      if (!metadata || state?.metadata === metadata) return;
      const current = collect(section);
      state = { ...current, grid: section.querySelector('.t4s-products'), original: [...section.querySelector('.t4s-products').children].map(n => n.cloneNode(true)), pool: null, promise: null };
      run();
    }
    function syncURL(query) {
      const url = new URL(location.href);
      query ? url.searchParams.set('lc_q', query) : url.searchParams.delete('lc_q');
      const path = url.pathname + url.search + url.hash;
      history.replaceState({ ...history.state, path }, '', path);
    }
    function reinit() {
      if (window.T4SThemeSP?.reinitProductGridItem) window.T4SThemeSP.reinitProductGridItem();
    }
    async function pool(current) {
      if (current.pool) return current.pool;
      if (current.promise) return current.promise;
      current.promise = (async () => {
        const records = [];
        for (let page = 1; page <= current.data.pages; page++) {
          if (current !== state) throw new Error('Stale search');
          if (page === current.data.page) { records.push(...current.records); continue; }
          const url = new URL(location.href);
          url.searchParams.delete('lc_q'); url.searchParams.set('page', page); url.searchParams.set('section_id', current.data.section);
          const response = await fetch(url, { credentials: 'same-origin' });
          if (!response.ok) throw new Error('Search request failed');
          const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
          records.push(...collect(doc).records);
        }
        current.pool = records;
        return records;
      })().catch(error => { current.promise = null; throw error; });
      return current.promise;
    }
    async function run() {
      if (!state) return;
      const ticket = ++generation, current = state, query = input.value.trim();
      clear.hidden = !query; syncURL(query);
      section.classList.toggle('lc-search-active', Boolean(query));
      if (!query) {
        current.grid.replaceChildren(...current.original.map(n => n.cloneNode(true)));
        current.grid.removeAttribute('aria-busy'); countResults(current.data.total); status.hidden = true; reinit(); return;
      }
      countResults('…'); status.hidden = false; status.textContent = ui.dataset.loading; current.grid.setAttribute('aria-busy', 'true');
      try {
        const records = await pool(current);
        if (ticket !== generation || current !== state) return;
        const terms = normal(query).split(' ').filter(Boolean), compact = normal(query).replaceAll(' ', '');
        const matches = records.filter(({item}) => {
          const title = normal(item.title);
          return terms.length && (terms.every(term => title.includes(term)) || item.skus.some(sku => normal(sku).replaceAll(' ', '').includes(compact)));
        });
        current.grid.replaceChildren(...matches.map(record => record.card.cloneNode(true)));
        countResults(matches.length);
        status.hidden = matches.length > 0;
        status.textContent = matches.length ? ui.dataset.count.replace('__COUNT__', matches.length) : ui.dataset.empty;
        reinit();
      } catch (error) {
        if (ticket === generation && current === state) { current.grid.replaceChildren(); countResults('—'); status.textContent = ui.dataset.error; }
      } finally { if (ticket === generation) current.grid.removeAttribute('aria-busy'); }
    }
    input.addEventListener('input', () => { clearTimeout(timer); timer = setTimeout(run, 220); });
    ui.querySelector('form').addEventListener('submit', event => { event.preventDefault(); clearTimeout(timer); run(); });
    clear.addEventListener('click', () => { input.value = ''; clearTimeout(timer); run(); input.focus(); });
    document.addEventListener('click', event => {
      const link = event.target.closest('[data-filter-links] a, .t4s-active-filters a, .lc-tout-voir-products .t4s-prs-footer a');
      if (!link) return;
      const url = new URL(link.href, location.href), query = input.value.trim();
      if (query) url.searchParams.set('lc_q', query);
      link.href = url.pathname + url.search + url.hash;
    }, true);
    window.addEventListener('popstate', () => { input.value = new URL(location.href).searchParams.get('lc_q') || ''; clear.hidden = !input.value; setTimeout(refresh, 100); });
    new MutationObserver(refresh).observe(section, { childList: true, subtree: true });
    refresh();
  }
  document.readyState === 'loading' ? document.addEventListener('DOMContentLoaded', start) : start();
})();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["lc-typography-tokens"] && !Shopify.designMode) return;
  try {
    function initLcChatClearance() {
    if (!document.body.matches('.template-index') || document.body.dataset.lcChatClearance) return;
    document.body.dataset.lcChatClearance = 'true';
    let pending = false;
    const check = () => {
      pending = false;
      const chat = document.querySelector('shopify-chat');
      if (!matchMedia('(max-width: 749px)').matches || !chat || chat.shadowRoot?.querySelector('shopify-agent-runtime[open]')) {
        document.body.classList.remove('lc-chat-avoid-overlap');
        return;
      }
      const area = { left: innerWidth - 70, right: innerWidth - 8, top: innerHeight - 70, bottom: innerHeight - 8 };
      const targets = document.querySelectorAll('#MainContent button, #MainContent a, #MainContent h3, #MainContent .lc-iconiques__price, #MainContent .lc-entries__controls, #MainContent .lc-entries__discover');
      const overlap = [...targets].some(element => {
        const r = element.getBoundingClientRect();
        return r.height > 0 && r.height <= 90 && r.width > 0 && r.left < area.right && r.right > area.left && r.top < area.bottom && r.bottom > area.top;
      });
      document.body.classList.toggle('lc-chat-avoid-overlap', overlap);
    };
    const schedule = () => { if (!pending) { pending = true; requestAnimationFrame(check); } };
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    document.addEventListener('shopify:section:load', schedule);
    check();
  }
  function initLcReviewHeading() {
    const textSource = document.getElementById('lc-review-heading-text');
    const root = document.getElementById('MainContent');
    if (!textSource || !root || root.dataset.lcHeadingReady) return;
    const label = JSON.parse(textSource.textContent);
    root.dataset.lcHeadingReady = 'true';
    const updateHeading = () => {
      root.querySelectorAll('h2.jdgm-carousel-title').forEach(heading => {
        if (heading.textContent !== label) heading.textContent = label;
      });
    };
    updateHeading();
    const observer = new MutationObserver(updateHeading);
    observer.observe(root, { childList: true, subtree: true, characterData: true });
    window.addEventListener('pagehide', () => observer.disconnect(), { once: true });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLcReviewHeading, { once: true });
    document.addEventListener('DOMContentLoaded', initLcChatClearance, { once: true });
  } else {
    initLcReviewHeading();
    initLcChatClearance();
  }
  document.addEventListener('shopify:section:load', initLcReviewHeading);
  } catch(e) { console.error(e); }
})();

})();
